// News taxonomy — matches the backend `NEWS_CATEGORIES` enum.
//
// PENDIENTE (backend): el enum viene heredado de TeleDeportes y trae DEPORTES,
// que no pinta nada en un festival de música. Mientras no cambie allá, el enum
// se respeta tal cual (es lo que la API acepta) y el nav público simplemente no
// expone esa sección — los artículos que la usen siguen apareciendo en TODAS.
// Cuando el backend adopte su propia taxonomía (MÚSICA, TRADICIÓN, TERRITORIO,
// GASTRONOMÍA…), este archivo es el único sitio que hay que tocar.
export const NEWS_CATEGORIES = ['NOTICIAS', 'DEPORTES', 'CULTURA', 'POLÍTICA'];

// Nav sections. Una entrada con `category` cambia la vista en la misma página;
// una con `to` navega a otra ruta (superficies propias, no categorías).
export const NAV_SECTIONS = [
    { key: 'home',     label: 'INICIO' },
    { key: 'noticias', label: 'NOTICIAS', category: 'NOTICIAS' },
    { key: 'cultura',  label: 'CULTURA',  category: 'CULTURA' },
    { key: 'politica', label: 'REGIÓN',   category: 'POLÍTICA' },
    { key: 'envivo',   label: 'EN VIVO',  to: '/vivo' },
    { key: 'todas',    label: 'TODAS' },
];

// Category page hero intro copy. The icon is an SVG mapped in category-page.jsx.
export const CATEGORY_META = {
    NOTICIAS: { blurb: 'Lo que pasa en el Pacífico y en el país, contado desde aquí.' },
    DEPORTES: { blurb: 'Deporte del Pacífico colombiano.' },
    CULTURA:  { blurb: 'Marimba, chirimía, currulao y la gente que sostiene la tradición viva.' },
    POLÍTICA: { blurb: 'Territorio, comunidad y las decisiones que tocan al Pacífico.' },
};

// Marquee headlines.
export const TICKER_ITEMS = [
    'XXX Festival de Música del Pacífico Petronio Álvarez',
    'Marimba de chonta, cununos y guasá en tarima',
    'Currulao, bunde y abozao desde Cali',
    'Cocina tradicional del Pacífico en el Quilombo',
];

// Formats an ISO date into the Spanish long form, e.g. "28 de febrero de 2026".
export function formatNewsDate(value) {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('es-CO', { day: 'numeric', month: 'long', year: 'numeric' });
}

// Trims a string to `max` chars with an ellipsis, matching the prototype cards.
export function truncate(text, max) {
    const s = String(text || '');
    return s.length > max ? `${s.slice(0, max)}…` : s;
}
